import { useProductContext } from "./productContext.mjs";
import { computed, reactive, ref, watch } from "vue";
const selectedBundleOptions = ref([]);
export function useBundleProductContext(_useProductContext = useProductContext) {
  const { product, appendProductValues } = _useProductContext();
  const items = computed(() => {
    return product.value.bundleItems;
  });
  const selectedOptions = reactive(
    items.value?.reduce(
      (acc, curr) => {
        acc[String(curr.id)] = {
          isRequired: curr.isRequired,
          value: (curr.options.find((opt) => opt.isDefault) || { id: "" }).id ?? "",
          price: curr.options.find((opt) => opt.price)?.price ?? 0,
          stock: curr.options?.[0]?.stock ?? 0,
          quantity: curr.options?.[0]?.qty ?? 1
        };
        return acc;
      },
      {}
    ) || {}
  );
  const mapOptionIds = () => {
    return Object.keys(selectedOptions).map(
      (itemId) => selectedOptions[itemId].value
    );
  };
  function onSelect(itemId, optionId) {
    const targetItem = items.value?.find((item2) => item2.id === itemId);
    const targetOption = targetItem?.options.find(
      (item2) => item2.id === optionId
    );
    if (!(targetItem && targetOption))
      return;
    const item = selectedOptions[itemId];
    if (item.value === optionId && !item.isRequired) {
      delete selectedOptions[itemId];
      return mapOptionIds();
    }
    item.value = optionId;
    selectedOptions[itemId] = {
      isRequired: targetItem?.isRequired,
      value: String(targetOption.id) || "",
      price: targetOption.price ?? 0,
      stock: targetOption.stock ?? 0,
      quantity: targetOption.qty ?? 1
    };
    return mapOptionIds();
  }
  const disableBundleOptions = computed(() => {
    return items.value?.every((item) => item.options.length === 1);
  });
  watch(
    selectedOptions,
    (newOptions) => {
      if (product.value.dynamicPrice) {
        appendProductValues({
          price: Object.values(newOptions).reduce((accu, option) => {
            return accu + option.price * option.quantity;
          }, 0),
          stock: Object.values(newOptions).reduce(
            (accu, option) => accu <= option.stock ? accu : option.stock,
            Number.MAX_VALUE
          )
        });
      }
      selectedBundleOptions.value = mapOptionIds();
    },
    {
      immediate: true
    }
  );
  return {
    onSelect,
    mapOptionIds,
    selectedOptions,
    items,
    disableBundleOptions,
    selectedBundleOptions
  };
}
